<template>
  <div id="Casedetail">
    <!-- 加载中组件 -->
    <loading-overlay v-if="isLoading"></loading-overlay>
    <!-- <h3>案件审批详情</h3> -->
    <div class="detail">
      <el-row>
        <el-col :span="19">
          <div class="Top" v-if="!casetype.includes('破产')">
            <el-steps space="100%" align-center>
              <el-step
                v-for="(item, i) in form.link"
                :title="item.name"
                :key="i"
                :status="item.result"
                @click.native="step_click(item.id)"
              ></el-step>
            </el-steps>
          </div>

          <div class="contain">
            <el-form
              class="form"
              ref="formref"
              :model="form"
              label-width="128px"
            >
              <div class="text">
                <div class="icon"></div>
                <div>案件信息</div>
              </div>
              <!-- 案件信息 按案件类型显示不同-->
              <!-- 民事案件  刑事案件 行政案件 仲裁案件-->
              <div
                v-if="
                  casetype == '民事案件' ||
                  casetype == '刑事案件' ||
                  casetype == '行政案件' ||
                  casetype == '劳动仲裁案件' ||
                  casetype == '商事仲裁案件' ||
                  casetype == '执行案件'
                "
              >
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="案件名称" prop="title">
                      <el-input v-model="form.title" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24" v-if="casetype == '行政案件'">
                    <el-form-item label="公益诉讼" prop="public_welfare">
                      <el-select
                        v-model="form.extInfo.public_welfare"
                        style="width: 100%"
                        disabled
                      >
                        <el-option
                          v-for="item in gyss"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="案件编号" prop="code">
                      <el-input
                        v-model="form.code"
                        placeholder="自动编号"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" v-if="casetype != '执行案件'">
                    <el-form-item label="法律援助" prop="aid">
                      <el-select
                        v-model="form.aid"
                        placeholder="请选择"
                        class="input"
                        disabled
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in flyz"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="案由" prop="cause">
                      <el-input v-model="form.cause" disabled></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <el-form-item label="案卷状态" prop="name">
                      <el-select
                        v-model="form.name"
                        placeholder="请选择"
                        class="input"
                        disabled
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in Ajstatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="false" :span="6">
                    <el-form-item label="受理状态" prop="casestatus">
                      <el-select
                        v-model="form.casestatus"
                        placeholder="请选择"
                        disabled
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in CaseStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6" class="date_box">
                    <el-form-item label="收案日期" prop="entrustmentTime">
                      <el-date-picker
                        style="width: 100%"
                        v-model="form.entrustmentTime"
                        type="date"
                        disabled
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="案件来源" prop="source">
                      <el-input v-model="form.source" disabled></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <el-form-item label="受理机构" prop="acceptUnit">
                      <el-input v-model="form.acceptUnit" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="受理机构案号" prop="acceptCode">
                      <el-input
                        v-model="form.acceptCode"
                        placeholder="请输入"
                        clearable
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="代理律师" prop="leadLawyer">
                      <el-select
                        style="width: 100%"
                        v-model="form.leadLawyer"
                        class="select"
                        multiple
                        disabled
                      >
                        <el-option
                          v-for="item in Lawyer"
                          :key="item.id"
                          :label="item.nikename"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="代理律师" prop="coCounsel">
                      <el-select
                        style="width: 100%"
                        v-model="form.coCounsel"
                        class="select"
                        disabled
                        multiple
                      >
                        <el-option
                          v-for="item in Lawyer"
                          :key="item.id"
                          :label="item.nikename"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <!-- <el-row>
                  <el-col :span="14">
                    <el-form-item label="代理律师" prop="lawyer2">
                      <el-select
                        style="width: 100%"
                        v-model="form.lawyer2"
                        class="select"
                        disabled
                      >
                        <el-option
                          v-for="item in Lawyer"
                          :key="item.id"
                          :label="item.nikename"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="委托事项" prop="entrust2">
                      <el-input v-model="form.entrust2" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row> -->

                  <el-col :span="12" v-if="false">
                    <el-form-item
                      label="委托事项"
                      prop="entrust"
                      v-if="casetype != '刑事案件'"
                    >
                      <el-input v-model="form.entrust" disabled></el-input>
                    </el-form-item>
                    <el-form-item
                      label="介入阶段"
                      prop="intervene"
                      v-if="casetype == '刑事案件'"
                    >
                      <el-select
                        style="width: 100%"
                        v-model="form.extInfo.intervene"
                        disabled
                      >
                        <el-option
                          v-for="item in step"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- <el-row>
                  <el-col :span="14">
                    <el-form-item label="二次审批人" prop="approve">
                      <el-select
                        style="width: 100%"
                        v-model="form.approve"
                        class="select"
                        disabled
                      >
                        <el-option
                          v-for="item in Approve"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" v-if="casetype == '刑事案件'">
                    <el-form-item label="刑事风险控制人" prop="fxkz">
                      <el-select
                        style="width: 100%"
                        v-model="form.fxkz"
                        class="select"
                        disabled
                      >
                        <el-option
                          v-for="item in fxkz"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row> -->
                <!-- <el-row
                  v-if="!casetype.includes('投标') && form.ptfile.length > 0"
                >
                  <el-col :span="14">
                    <el-form-item label="普通附件">
                      <div
                        v-for="item in form.ptfile"
                        :key="item.id"
                        class="upload_file"
                      >
                        <div class="fj">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf'"
                            />
                          </div>
                          <div class="fname" style="flex: 9">
                            <div>
                              {{ item.fname }}
                            </div>
                            <div class="word">
                              <span
                                @click="look(item)"
                                class="look"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_look'
                                  )
                                "
                                >预览</span
                              >
                              <span
                                class="down"
                                @click="down(item)"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_down'
                                  )
                                "
                                >下载</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row> -->
                <div class="divider"></div>

                <!-- 案件当事人 -->
                <div class="text">
                  <div class="icon"></div>
                  <div>案件当事人</div>
                </div>
                <div class="party">
                  <el-table
                    class="party"
                    border
                    :data="form.tableData"
                    style="width: 100%"
                    :header-cell-style="{ textAlign: 'center' }"
                    :cell-style="{ textAlign: 'center' }"
                    :row-class-name="rowStyle"
                  >
                    <el-table-column label="属性" prop="attribute"  width="150">
                    </el-table-column>
                    <el-table-column label="类型" prop="isUnit"  width="150">
                      <template slot-scope="scope">
                        <span v-if="scope.row.isUnit">个人</span>
                        <span v-else>单位</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="姓名/单位名称" prop="name">
                    </el-table-column>
                    <el-table-column label="身份证号/社会信用代码" prop="idnumber">
                    </el-table-column>
                    <el-table-column label="委托方" prop="isClient"  width="100">
                      <template slot-scope="scope">
                        <span v-if="scope.row.isClient">是</span>
                        <span v-else>否</span>
                      </template>

                      <!-- <template  slot-scope="scope">
                      <el-select size="mini"  v-model="scope.row.client">
                        <el-option v-for="item in options.Type"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>  
                    </template> -->
                    </el-table-column>
                   
                  </el-table>
                </div>
              </div>
              <!-- 非诉案件 -->
              <div v-else>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="项目名称" prop="title">
                      <el-input v-model="form.title" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row
                  v-if="
                    casetype != '一般非诉项目' &&
                    casetype != '单独出具法律意见审批书' &&
                    casetype != '证券类业务' &&
                    casetype != '单独出具律师函'
                  "
                >
                  <el-col :span="24">
                    <el-form-item label="受理机构案号" prop="acceptCode">
                      <el-input
                        v-model="form.acceptCode"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="项目概要" prop="cause">
                      <el-input
                        v-model="form.cause"
                        placeholder=""
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <el-form-item label="案件编号" prop="code">
                      <el-input
                        v-model="form.code"
                        placeholder="自动编号"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="6"
                    v-if="casetype != '破产案件投标' && casetype != '破产案件'"
                  >
                    <el-form-item label="案卷状态" prop="name">
                      <el-select
                        v-model="form.name"
                        placeholder="请选择"
                        class="input"
                        disabled
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in Ajstatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col v-if="false" :span="6">
                    <el-form-item label="受理状态" prop="casestatus">
                      <el-select
                        v-model="form.casestatus"
                        placeholder="请选择"
                        class="select"
                        disabled
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in CaseStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" v-if="casetype == '破产案件'">
                  <el-form-item label="破产案件类型" prop="extInfo.projecttype">
                    <el-select  disabled
                      style="width: 100%"
                      v-model="form.extInfo.projecttype"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in ProjectType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="项目合伙人" prop="partner">
                      <el-input
                        v-model="form.extInfo.partner"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="底稿资料" prop="draft">
                      <el-select
                        v-model="form.extInfo.draft"
                        placeholder="请选择"
                        class="select"
                        disabled
                      >
                        <el-option
                          v-for="item in Draft"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <!-- 一般非诉项目、单独出具法律意见审批书、单独出具律师函没有二次审批人 -->
                  <!-- <el-row
                  v-if="
                    casetype != '一般非诉项目' &&
                    casetype != '单独出具法律意见审批书' &&
                    casetype != '单独出具律师函'
                  "
                >
                  <el-col :span="14">
                    <el-form-item label="二次审批人" prop="approve">
                      <el-select
                        style="width: 100%"
                        v-model="form.approve"
                        class="select"
                        disabled
                      >
                        <el-option
                          v-for="item in Approve"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row> -->
                  <!-- <div class="divider"></div> -->

                  <el-col :span="6" class="date_box">
                    <!-- <el-form-item label="立项日期" prop="postTime" v-if="casetype == '破产案件'||casetype == '破产案件投标'" >
                      <el-date-picker
                        disabled
                        style="width: 100%"
                        v-model="form.postTime"
                        type="date"
                        placeholder="请选择日期"
                      >
                      </el-date-picker>
                    </el-form-item> -->
                    <el-form-item label="立项日期" prop="entrustmentTime" >
                      <el-date-picker
                        disabled
                        style="width: 100%"
                        v-model="form.entrustmentTime"
                        type="date"
                        placeholder="请选择日期"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="项目来源" prop="source">
                      <el-input
                        disabled
                        v-model="form.source"
                        placeholder="请输入"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <el-form-item
                      :label="
                        casetype == '破产案件'
                          ? '管辖法院'
                          : casetype.includes('投标')
                          ? '代理机构'
                          : '受理机构'
                      "
                      prop="acceptUnit"
                    >
                      <el-input v-model="form.acceptUnit" disabled></el-input>
                    </el-form-item>
                  </el-col>

                  <!-- <el-col
                    :span="14"
                    v-if="
                      casetype == '一般非诉项目' ||
                      casetype == '专项服务合同' ||
                      casetype == '单独出具法律意见审批书' ||
                      casetype == '单独出具律师函'
                    "
                  >
                    <el-form-item label="项目分类" prop="classification">
                      <el-input
                        v-model="form.extInfo.classification"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col> -->
                  <el-col :span="6" v-if="casetype.includes('投标')">
                    <el-form-item label="项目类型" prop="projecttype">
                      <el-select
                        style="width: 100%"
                        v-model="form.extInfo.projecttype"
                        disabled
                      >
                        <el-option
                          v-for="item in ptype"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :span="6">
                    <el-form-item
                      :label="
                        casetype.includes('投标') ? '服务律师' : '代理律师'
                      "
                      prop="leadLawyer"
                    >
                      <el-select
                        style="width: 100%"
                        v-model="form.leadLawyer"
                        class="select"
                        disabled
                        multiple
                      >
                        <el-option
                          v-for="item in Lawyer"
                          :key="item.id"
                          :label="item.nikename"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="代理律师" prop="coCounsel">
                      <el-select
                        style="width: 100%"
                        v-model="form.coCounsel"
                        class="select"
                        disabled
                        multiple
                      >
                        <el-option
                          v-for="item in Lawyer"
                          :key="item.id"
                          :label="item.nikename"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- <el-row
                  v-if="
                    casetype == '一般非诉项目' ||
                    casetype == '单独出具法律意见审批书' ||
                    casetype == '单独出具律师函'
                  "
                >
                  <el-col :span="14">
                    <el-form-item label="风控委" prop="risk">
                      <el-select
                        style="width: 100%"
                        v-model="form.risk"
                        class="select"
                        disabled
                        multiple
                      >
                        <el-option
                          v-for="item in fkw"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row> -->
                <!-- 破产案件独有字段 -->
                <div v-if="casetype == '破产案件'">
                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="案件级别" prop="caselevel">
                        <el-select
                          disabled
                          style="width: 100%"
                          v-model="form.extInfo.caselevel"
                          placeholder="请选择"
                          class="select"
                        >
                          <el-option
                            v-for="item in Level"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="项目负责人" prop="porjectleader">
                        <el-input
                          disabled
                          v-model="form.extInfo.porjectleader"
                          placeholder="请输入"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="6">
                      <el-form-item label="管理人账号" prop="administrator">
                        <el-select
                          disabled
                          style="width: 100%"
                          v-model="form.extInfo.administrator"
                          placeholder="请选择"
                          class="select"
                        >
                          <el-option
                            v-for="item in Administrator"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="开户账号" prop="account">
                        <el-input
                          disabled
                          v-model="form.extInfo.account"
                          placeholder="请输入"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="开户银行" prop="bank">
                        <el-input
                          disabled
                          v-model="form.extInfo.bank"
                          placeholder="请输入"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="委托人摇号" prop="lottery">
                        <el-input
                          disabled
                          v-model="form.extInfo.lottery"
                          placeholder="请输入"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <!-- 与其他法律服务有关的招投标项目栏独有字段 -->
                <div v-if="casetype.includes('投标')">
                  <el-col :span="12">
                    <el-form-item label="开放时间" prop="opentime">
                      <el-date-picker
                        disabled
                        style="width: 100%"
                        v-model="form.extInfo.opentime"
                        type="date"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="采购方式" prop="procuremethod">
                      <el-input
                        disabled
                        v-model="form.extInfo.procuremethod"
                        placeholder="请输入"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="预算金额" prop="budgetmoney">
                        <el-input
                          disabled
                          v-model="form.extInfo.budgetmoney"
                          placeholder="请输入"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="采购编号" prop="procurecode">
                        <el-input
                          disabled
                          v-model="form.extInfo.procurecode"
                          placeholder="请输入"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <!-- 专项服务合同独有字段 -->
                <div
                  v-if="casetype == '专项服务合同' || casetype == '律师见证'"
                >
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="合同服务类型" prop="contracttype">
                        <el-input
                          disabled
                          v-model="form.extInfo.contracttype"
                          placeholder="请输入"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="服务期限" prop="servicetime">
                        <el-date-picker
                          disabled
                          style="width: 100%"
                          v-model="form.extInfo.servicetime"
                          type="date"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>

                <!-- <div class="divider"></div> -->

                <el-row>
                  <el-col :span="12" v-if="casetype == '破产案件'">
                    <el-form-item label="债务人名称" prop="debtorName">
                      <el-input
                        v-model="form.extInfo.debtorName"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="12"
                    v-if="
                      casetype != '破产案件' && casetype != '单独出具律师函'
                    "
                  >
                    <el-form-item
                      :label="
                        casetype.includes('投标') ? '采购单位' : '客户名称'
                      "
                      prop="procureunit"
                    >
                      <el-input
                        v-model="form.extInfo.procureunit"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="12" 
                    v-if=" casetype != '单独出具律师函'&&!casetype.includes('投标')
                    "
                  >
                    <el-form-item label-width="200px"
                      label="身份证号/社会信用代码
                      "
                      prop="procureunit"
                    >
                      <el-input
                        v-model="form.extInfo.idnumber"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div v-if="casetype == '单独出具律师函'">
                <div class="divider"></div>
                <div class="text">
                  <div class="icon"></div>
                  <div>案件当事人</div>
                </div>
                <!-- 案件当事人 -->
                <div class="party">
                  <el-table
                    class="party"
                    border
                    :data="form.tableData"
                    style="width: 100%"
                    :header-cell-style="{ textAlign: 'center' }"
                    :cell-style="{ textAlign: 'center' }"
                    :row-class-name="rowStyle"
                  >
                    <el-table-column label="属性" prop="attribute"  width="150">
                    </el-table-column>
                    <el-table-column label="姓名/单位名称" prop="name">
                    </el-table-column>
                    <el-table-column label="身份证号/社会信用代码" prop="idnumber"></el-table-column>
                    <el-table-column label="委托方" prop="isClient"  width="100">
                      <template slot-scope="scope">
                        <span v-if="scope.row.isClient">是</span>
                        <span v-else>否</span>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column label="类型" prop="isUnit">
                      <template slot-scope="scope">
                        <span v-if="scope.row.isUnit">个人</span>
                        <span v-else>单位</span>
                      </template>
                    </el-table-column> -->
                  </el-table>
                </div>
              </div>

              <div class="divider"></div>

              <div class="text">
                <div class="icon"></div>
                <div>附件信息</div>
              </div>

              <!-- 附件 每个类型附件字段不同-->

              <el-row
                v-if="
                  !casetype.includes('投标') &&
                  casetype != '破产案件' 
                  &&
                  form.ptfile.length > 0
                "
              >
                <el-col :span="12">
                  <el-form-item label="普通附件">
                    <div
                      v-for="item in form.ptfile"
                      :key="item.id"
                      class="upload_file"
                    >
                      <div class="fj">
                        <div style="flex: 1">
                          <img
                            src="../../assets/file/word.svg"
                            v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                          />
                          <img
                            src="../../assets/file/xls.svg"
                            v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                          />
                          <img
                            src="../../assets/file/png.svg"
                            v-if="
                              item.ftype == 'jpg' ||
                              item.ftype == 'jpeg' ||
                              item.ftype == 'png'
                            "
                          />
                          <img
                            src="../../assets/file/PDF.svg"
                            v-if="item.ftype == 'pdf'"
                          />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.fname }}
                          </div>
                          <div class="word">
                            <span
                              @click="look(item)"
                              class="look"
                              v-if="
                                $store.state.rolesname.includes(
                                  'Casedetail_look'
                                )
                              "
                              >预览</span
                            >
                            <span
                              class="down"
                              @click="down(item)"
                              v-if="
                                $store.state.rolesname.includes(
                                  'Casedetail_down'
                                )
                              "
                              >下载</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <div v-if="casetype != '破产案件'">
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      :label="
                        casetype.includes('投标') ? '招标文件' : '合同上传'
                      "
                    >
                      <div
                        v-for="item in form.contractfile"
                        :key="item.id"
                        class="upload_file"
                      >
                        <div class="fj">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf'"
                            />
                          </div>
                          <div class="fname" style="flex: 9">
                            <div>
                              {{ item.fname }}
                            </div>
                            <div class="word">
                              <span
                                @click="look(item)"
                                class="look"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_look'
                                  )
                                "
                                >预览</span
                              >
                              <span
                                class="down"
                                @click="down(item)"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_down'
                                  )
                                "
                                >下载</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col
                    v-if="casetype.includes('投标') && form.ptfile.length > 0"
                    :span="12"
                  >
                    <el-form-item label="普通附件">
                      <div
                        v-for="item in form.ptfile"
                        :key="item.id"
                        class="upload_file"
                      >
                        <div class="fj">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf'"
                            />
                          </div>
                          <div class="fname" style="flex: 9">
                            <div>
                              {{ item.fname }}
                            </div>
                            <div class="word">
                              <span
                                @click="look(item)"
                                class="look"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_look'
                                  )
                                "
                                >预览</span
                              >
                              <span
                                class="down"
                                @click="down(item)"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_down'
                                  )
                                "
                                >下载</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="form.freeFile.length > 0">
                  <el-col :span="14">
                    <el-form-item label="免费凭证">
                      <div
                        v-for="item in form.freeFile"
                        :key="item.id"
                        class="upload_file"
                      >
                        <div class="fj">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf'"
                            />
                          </div>
                          <div class="fname" style="flex: 9">
                            <div>
                              {{ item.fname }}
                            </div>
                            <div class="word">
                              <span
                                @click="look(item)"
                                class="look"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_look'
                                  )
                                "
                                >预览</span
                              >
                              <span
                                class="down"
                                @click="down(item)"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_down'
                                  )
                                "
                                >下载</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-col :span="12" v-if="casetype=='一般非诉项目'||casetype.includes('单独出具')">
                  <el-form-item label="拟出具文件">
                    <div
                      v-for="item in form.chujuFiles"
                      :key="item.id"
                      class="upload_file"
                    >
                      <div class="fj">
                        <div style="flex: 1">
                          <img
                            src="../../assets/file/word.svg"
                            v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                          />
                          <img
                            src="../../assets/file/xls.svg"
                            v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                          />
                          <img
                            src="../../assets/file/png.svg"
                            v-if="
                              item.ftype == 'jpg' ||
                              item.ftype == 'jpeg' ||
                              item.ftype == 'png'
                            "
                          />
                          <img
                            src="../../assets/file/PDF.svg"
                            v-if="item.ftype == 'pdf'"
                          />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.fname }}
                          </div>
                          <div class="word">
                            <span
                              @click="look(item)"
                              class="look"
                              v-if="
                                $store.state.rolesname.includes(
                                  'Casedetail_look'
                                )
                              "
                              >预览</span
                            >
                            <span
                              class="down"
                              @click="down(item)"
                              v-if="
                                $store.state.rolesname.includes(
                                  'Casedetail_down'
                                )
                              "
                              >下载</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </div>

              <!-- 破产案件附件字段 -->
              <div v-if="casetype == '破产案件'">
                <el-row>
                  <el-col :span="14" v-if="this.bcshow">
                    <el-form-item label="投标方案">
                      <div
                        v-for="item in form.bidfile"
                        :key="item.id"
                        class="upload_file"
                      >
                        <div class="fj">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf'"
                            />
                          </div>
                          <div class="fname" style="flex: 9">
                            <div>
                              {{ item.fname }}
                            </div>
                            <div class="word">
                              <span
                                @click="look(item)"
                                class="look"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_look'
                                  )
                                "
                                >预览</span
                              >
                              <span
                                class="down"
                                @click="down(item)"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_down'
                                  )
                                "
                                >下载</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="this.bcshow">
                  <el-col :span="14">
                    <el-form-item label="法院的受理裁定书">
                      <div
                        v-for="item in form.rulingfile"
                        :key="item.id"
                        class="upload_file"
                      >
                        <div class="fj">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf'"
                            />
                          </div>
                          <div class="fname" style="flex: 9">
                            <div>
                              {{ item.fname }}
                            </div>
                            <div class="word">
                              <span
                                @click="look(item)"
                                class="look"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_look'
                                  )
                                "
                                >预览</span
                              >
                              <span
                                class="down"
                                @click="down(item)"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_down'
                                  )
                                "
                                >下载</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="this.bcshow">
                  <el-col :span="14">
                    <el-form-item label="管理人决定书">
                      <div
                        v-for="item in form.administratorDecision"
                        :key="item.id"
                        class="upload_file"
                      >
                        <div class="fj">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf'"
                            />
                          </div>
                          <div class="fname" style="flex: 9">
                            <div>
                              {{ item.fname }}
                            </div>
                            <div class="word">
                              <span
                                @click="look(item)"
                                class="look"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_look'
                                  )
                                "
                                >预览</span
                              >
                              <span
                                class="down"
                                @click="down(item)"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_down'
                                  )
                                "
                                >下载</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="form.freeFile.length > 0">
                  <el-col :span="14">
                    <el-form-item label="免费凭证">
                      <div
                        v-for="item in form.freeFile"
                        :key="item.id"
                        class="upload_file"
                      >
                        <div class="fj">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf'"
                            />
                          </div>
                          <div class="fname" style="flex: 9">
                            <div>
                              {{ item.fname }}
                            </div>
                            <div class="word">
                              <span
                                @click="look(item)"
                                class="look"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_look'
                                  )
                                "
                                >预览</span
                              >
                              <span
                                class="down"
                                @click="down(item)"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_down'
                                  )
                                "
                                >下载</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="form.ptfile.length > 0">
                  <el-col :span="14">
                    <el-form-item label="普通附件">
                      <div
                        v-for="item in form.ptfile"
                        :key="item.id"
                        class="upload_file"
                      >
                        <div class="fj">
                          <div style="flex: 1">
                            <img
                              src="../../assets/file/word.svg"
                              v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                            />
                            <img
                              src="../../assets/file/xls.svg"
                              v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                            />
                            <img
                              src="../../assets/file/png.svg"
                              v-if="
                                item.ftype == 'jpg' ||
                                item.ftype == 'jpeg' ||
                                item.ftype == 'png'
                              "
                            />
                            <img
                              src="../../assets/file/PDF.svg"
                              v-if="item.ftype == 'pdf'"
                            />
                          </div>
                          <div class="fname" style="flex: 9">
                            <div>
                              {{ item.fname }}
                            </div>
                            <div class="word">
                              <span
                                @click="look(item)"
                                class="look"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_look'
                                  )
                                "
                                >预览</span
                              >
                              <span
                                class="down"
                                @click="down(item)"
                                v-if="
                                  $store.state.rolesname.includes(
                                    'Casedetail_down'
                                  )
                                "
                                >下载</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="divider"></div>

              <div class="text">
                <div class="icon"></div>
                <div>收费信息</div>
              </div>
              <!-- 收费信息 几乎一致 破产案件多两个字段 -->
              <el-row>
                <el-col :span="14">
                  <el-form-item label="收费方式" prop="chargingMethod">
                    <el-select
                      style="width: 100%"
                      v-model="form.chargingMethod"
                      placeholder="请选择"
                      class="select"
                      disabled
                    >
                      <el-option
                        v-for="item in chargestatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6" class="money" v-if="this.bcshow">
                  <el-form-item
                    :label="casetype.includes('投标') ? '投标价格' : '标的金额'"
                    prop="amountOfSubject"
                  >
                    <!-- <template>标的金额</template> -->
                    <el-input
                      v-model="form.amountOfSubject"
                      placeholder="请输入"
                      disabled
                    ></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="!casetype.includes('投标')">
                  <el-form-item label="案件标的物" prop="subjectMatter ">
                    <el-input
                      v-model="form.subjectMatter"
                      placeholder="请输入"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="简介" prop="introduction">
                    <el-input
                      v-model="form.introduction"
                      placeholder="请输入"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="备注" prop="remark ">
                    <el-input
                      v-model="form.remark"
                      placeholder="请输入"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6" class="money" v-if="this.bcshow">
                  <!-- 定额收费金额 -->
                  <el-form-item
                    label="收费金额"
                    prop="fixed"
                    v-if="form.chargingMethod == '固定收费'"
                  >
                    <el-input
                      v-model="form.fixed"
                      placeholder="请输入"
                      disabled
                    ></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                  <!-- 风险收费金额 -->
                  <el-form-item
                    label="收费金额"
                    prop="riskFixed"
                    v-if="form.chargingMethod == '风险收费'"
                  >
                    <el-input
                      v-model="form.riskFixed"
                      placeholder="请输入"
                      disabled
                    ></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="6"
                  v-if="form.chargingMethod == '风险收费'"
                  class="money"
                >
                  <el-form-item label="风险收费比例" prop="riskRatio ">
                    <el-input
                      v-model="form.riskRatio"
                      placeholder="请输入"
                      disabled
                    ></el-input>
                    <div style="margin-left: 4px">%</div>
                  </el-form-item>
                </el-col>

                <!-- 破产案件独有字段 -->

                <el-col v-if="casetype == '破产案件'" :span="6">
                  <el-form-item label="债务人资产情况" prop="asset">
                    <el-input
                      v-model="form.extInfo.asset"
                      placeholder="不小于0"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col v-if="casetype == '破产案件'" :span="6">
                  <el-form-item label="抵押债权金额" prop="debenture ">
                    <el-input
                      v-model="form.extInfo.debenture"
                      placeholder="不小于0"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row v-if="form.seal.newsType == null">
                <el-col :span="14">
                  <el-form-item
                    :label="casetype.includes('投标') ? '申请用章' : '合同用章'"
                    prop="seal.sealType"
                  >
                    <el-select
                      style="width: 100%"
                      v-model="form.seal.sealType"
                      placeholder="请选择"
                      class="select"
                      disabled
                    >
                      <el-option
                        v-for="item in seal"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 收费明细 全部案件都有-->
              <div v-if="false">
                <div
                  v-if="form.chargingMethod != '免费' && form.riskFixed != 0"
                >
                  <div class="divider"></div>
                  <div class="text">
                    <div class="icon"></div>
                    <div>收费明细</div>
                  </div>
                  <el-row style="margin-left: 35px">
                    <el-table
                      class="party"
                      border
                      :data="form.bcbdTable"
                      style="width: 100%"
                      :header-cell-style="{ textAlign: 'center' }"
                      :cell-style="{ textAlign: 'center' }"
                    >
                      <el-table-column label="款项名称" prop="name">
                        <!-- <template slot-scope="scope">
                        <el-input v-model="scope.row.name" placeholder="请输入" clearable></el-input>
                      </template> -->
                      </el-table-column>
                      <el-table-column label="应收金额" prop="amount">
                        <!-- <template slot-scope="scope">
                        <el-input v-model="scope.row.amount" placeholder="请输入" clearable></el-input>
                      </template> -->
                      </el-table-column>
                      <el-table-column label="约定收款日期" prop="paymentDate">
                        <template slot-scope="scope">
                          {{ handleTime(scope.row.paymentDate) }}
                        </template>
                      </el-table-column>
                      <el-table-column label="状态" prop="status">
                        <template slot-scope="scope">
                          {{ ChangeStaue(scope.row.status) }}
                        </template>
                      </el-table-column>
                      <el-table-column label="备注" prop="remark">
                        <!-- <template slot-scope="scope">
                        <el-input v-model="scope.row.remark" placeholder="请输入"></el-input>
                      </template> -->
                      </el-table-column>
                      <!-- <el-table-column label="操作">
                      <template slot-scope="scope">
                        <span class="copy" @click="copy(scope.row)">复制</span>
                        <span class="bgdel" v-if="bcbdTable.length > 1"
                          @click="reduceCharge(scope.$index)">删除</span>
                      </template>
                    </el-table-column> -->
                    </el-table>
                  </el-row>
                </div>
              </div>
              <!--关联案件  破产案件没有 -->
              <!-- <div v-if="casetype != '破产案件'">
                <div class="divider"></div>
                <div class="text">
                  <div class="icon"></div>
                  <div>关联案件</div>
                </div>
                <el-row>
                  <el-col :span="14">
                    <el-form-item label="关联案件" prop="LinkId">
                      <el-select
                        style="width: 100%"
                        v-model="form.LinkId"
                        placeholder="请选择"
                        class="select"
                        disabled
                      >
                        <el-option
                          v-for="item in LinkCase"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div> -->
              <!-- <div v-if="form.seal.newsType"> -->
              <div v-if="false">
                <div class="divider"></div>
                <div class="text">
                  <div class="icon"></div>
                  <div>用章申请</div>
                </div>
                <el-row>
                  <el-col :span="24">
                    <div style="margin-left: 10%">
                      <div>支持导出的材料：</div>
                      <div style="display: flex">
                        <div>
                          <el-checkbox-group v-model="checkedCities">
                            <el-checkbox
                              style="display: block; padding-top: 20px"
                              v-for="city in cities"
                              :label="city.name"
                              :key="city.name"
                              disabled
                              >{{ city.name }}
                            </el-checkbox>
                          </el-checkbox-group>
                        </div>

                        <div>
                          <div
                            style="margin-left: 15%; padding-top: 12px"
                            v-for="city in cities"
                          >
                            <el-select
                              size="mini"
                              v-model="city.stype"
                              placeholder="请选择用章类型"
                              disabled
                              value-key="value"
                              multiple
                            >
                              <el-option
                                v-for="item in seal"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </div>

          <div class="divider"></div>
          <div class="text">
            <div class="icon"></div>
            <div>关联案件</div>
          </div>
          <div
            style="width: 100%; padding-left: 3.625rem; font-size: 14px"
            v-if="cStatus == 0"
          >
            <div style="margin-bottom: 14px">
              <!-- <div v-if="AllBidCase.length>0"><span style="color: #3077e6;">相关的投标案件：</span>
               </div> -->
              <div
                v-for="item in AllBidCase"
                :key="item.id"
                style="cursor: pointer"
                @click="chakan(item)"
              >
                {{ item.title }}
              </div>
            </div>
            <div>
              <!-- <div v-if="AllBankruptCase.length>0" style="color: #3077e6;"><span v-if="casetype!='破产投标'">与投标案件</span>相关的破产案件：</span>
               </div> -->
              <div
                v-for="item in AllBankruptCase"
                :key="item.id"
                style="cursor: pointer"
                @click="chakan(item)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>

          <div
            style="width: 100%; padding-left: 3.625rem; font-size: 14px"
            v-if="cStatus == 1"
          >
            <div style="margin-bottom: 14px">
              <!-- <div v-if="AllCase.length>0"><span style="color: #3077e6;">关联案件：</span>
             </div> -->
              <div
                v-for="item in AllCase"
                :key="item.id"
                style="cursor: pointer"
                @click="chakan(item)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
        </el-col>

        <el-col :span="5">
          <div class="right">
            <el-timeline :reverse="false">
              <el-timeline-item
                v-for="(item, index) in logs"
                :key="index"
                color="#3077E6"
                :timestamp="item.reason"
              >
                <div style="display: flex; justify-content: space-between">
                  <div>{{ item.content }}</div>

                  <div class="time">
                    {{ handle(item.timestamp) }}
                  </div>
                </div>
                <div style="color: #909399">{{ item.type }}</div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="right" v-if="processlogs.length > 0">
            <div style="margin-bottom: 10px; font-weight: 600">已审核流程</div>
            <el-timeline :reverse="false">
              <el-timeline-item
                v-for="(item, index) in processlogs"
                :key="index"
                color="#3077E6"
                :timestamp="item.reason"
              >
                <div style="display: flex; justify-content: space-between">
                  <div>{{ item.type }}</div>

                  <div class="time">
                    {{ item.timestamp }}
                  </div>
                </div>
                <div style="color: #909399">{{ item.name }} {{ item.con }}</div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="right" v-if="Process.length > 0">
            <div style="margin-bottom: 10px; font-weight: 600">未审核</div>
            <el-timeline :reverse="false">
              <el-timeline-item
                v-for="(item, index) in Process"
                :key="index"
                :timestamp="item.type"
              >
                {{ item.name }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="footer">
      <el-button
        type="primary"
        @click="approval(0)"
        v-if="
          $store.state.rolesname.includes('Caseapprove_pass') &&
          !IsReacord &&
          shbtn
        "
        >通过</el-button
      >
      <el-button
        class="tjtg"
        @click="approvalReason(0)"
        v-if="
          $store.state.rolesname.includes('Caseapprove_pass') &&
          !IsReacord &&
          shbtn
        "
        >有条件通过</el-button
      >
      <el-button
        type="warning"
        @click="approval(1)"
        v-if="
          $store.state.rolesname.includes('Caseapprove_refuse') &&
          !IsReacord &&
          shbtn
        "
        >驳回</el-button
      >
      <el-button class="history" @click="history">返回</el-button>
    </div>
    <!-- 有条件通过 -->
    <el-dialog
      :title="title"
      :visible.sync="tjSuccessdialog"
      width="30%"
      center
      :show-close="false"
      @close="handleCancle"
    >
      <div class="fail" v-if="title">
        <el-form
          :model="successform"
          label-width="80px"
          ref="successformref"
          :rules="successformrules"
        >
          <el-form-item prop="Reason" label="通过条件" v-if="isTj">
            <el-input
              v-model="successform.Reason"
              :autosize="{ minRows: 8 }"
              type="textarea"
            />
          </el-form-item>
          <el-form-item prop="RemarkApproval" label="备注" v-else>
            <el-input
              v-model="successform.RemarkApproval"
              :autosize="{ minRows: 8 }"
              type="textarea"
            />
          </el-form-item>
        </el-form>
        <div
          class="refuse"
          v-if="$store.state.rolesname.includes('Caseapprove_refuse')"
        >
          <el-button @click="SuccessTJ('successformref')" v-if="isTj" type="primary"
            >有条件通过</el-button
          >
          <el-button @click="SuccessTJ('successformref')" v-else type="primary"
            >通过</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="title"
      :visible.sync="approvaldialog"
      width="30%"
      center
      :show-close="false"
      @close="handleCancle"
    >
      <div class="fail" v-if="title">
        <el-form
          :model="failform"
          label-width="80px"
          ref="failformref"
          :rules="failformrules"
        >
          <el-form-item prop="Reason" label="驳回原因">
            <el-input
              v-model="failform.Reason"
              :autosize="{ minRows: 8 }"
              type="textarea"
            />
          </el-form-item>
        </el-form>
        <div
          class="refuse"
          v-if="$store.state.rolesname.includes('Caseapprove_refuse')"
        >
          <el-button @click="refuse('failformref')" type="primary"
            >驳回</el-button
          >
        </div>
      </div>
      <div class="success" v-else>
        <div><img src="../../assets/success.svg" /></div>
        <div class="pass">已通过</div>
      </div>
    </el-dialog>

    <!-- 预览dialog -->
    <el-dialog
      center
      title="文件预览"
      :visible.sync="dialogVisible"
      append-to-body
      class="file-dialog"
      width="70%"
      @close="close"
    >
      <div v-if="isImage">
        <iframe
          id="printIframe"
          :src="imgUrl"
          frameborder="0"
          style="width: 100%; height: 600px"
        />
      </div>
      <!-- word -->
      <!-- //图片不会过大的写法但是有空白 要引入docx-preview-->
      <!-- <div v-if="isWord" ref="word"  style="width: 100%"></div> -->
      <!-- //图片过大，无空白 -->
      <div v-if="isWord" v-html="vHtml" style="width: 100%"></div>
      <!-- excel -->
      <div v-if="isExcel">
        <el-table
          :data="excelData"
          border
          stripe
          :header-cell-style="{ background: '#F5F4F7' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            :resizable="false"
            align="center"
          />
          <el-table-column
            v-for="(value, key, index) in excelData[0]"
            :key="index"
            :prop="key"
            :label="key"
          />
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
    
<script>
import {
  Detail,
  Conflict,
  Success,
  Reject,
  AdviserConflict
} from '../../api/examine'
import {
  CaseLog,
  CaseProcess,
  CaseApprover,
  LinkCase
} from '../../api/bankrupt'
import { user } from '../../api/seal'
import { requestDownLoadFile } from '../../api/seal'
import {
  requestDownLoadFile as YuLan,
  requestReview
} from '../../api/counsel.js'
import mammoth from 'mammoth'
// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
const docx = require('docx-preview')
const XLSX = require('xlsx')
var reason = (rule, value, callback) => {
  if (value == '' || value == undefined || value == null) {
    callback()
  } else {
    if (value.match(/^[ ]*$/)) {
      callback(new Error('驳回原因不能为空'))
    }
  }
  callback()
}
export default {
  name: 'Casedetail',
  data() {
    return {
      ProjectType:[{label:"重整案件",value:"重整案件"},{label:"预重整",value:"预重整"},{label:"公益案件",value:"公益案件"}],
      bcshow:true,
      shbtn: false,
      cStatus: -1,
      AllBidCase: [], //投标案件
      AllBankruptCase: [], //破产案件
      AllCase: [], // 其他案件
      isLoading: false,
      Guid: '',
      casetype: '', //案件类型
      path: '', //项目类型（非诉项目下面的投标）
      green: null, // 已过
      redOrYellow: null, //审核中/未过
      Isapproval: false, //审核成功或失败
      listprocess: [
        { procenname: '一审', standard: '2022' },
        { procenname: '二审', standard: '2022' }
      ],
      fkw: [], //风控委
      Ajstatus: [
        { label: '无', value: '无' },
        { label: '一审', value: '一审' },
        { label: '二审', value: '二审' },
        { label: '再审', value: '再审' },
        { label: '破产申报', value: '破产申报' },
        { label: '破产申请', value: '破产申请' },
        { label: '再审听证', value: '再审听证' },
        { label:'强制清算',value:'强制清算'},
        { label: '行政复议', value: '行政复议' },
        { label: '首次执行', value: '首次执行' },
        { label: '恢复执行', value: '恢复执行' },
        { label: '执行异议', value: '执行异议' },
        { label: '仲裁阶段', value: '仲裁阶段' },
        { label: '侦查阶段', value: '侦查阶段' },
        { label: '审查起诉', value: '审查起诉' }
        // { label: '受理', value: '受理' },
        // { label: '未受理', value: '未受理' }
      ],
      CaseStatus: [
        { label: '受理', value: '受理' },
        { label: '未受理', value: '未受理' }
      ],
      flyz: [
        { label: '是', value: true },
        { label: '否', value: false }
      ], // 法律援助
      fxkz: [], //风险控制人
      gyss: [
        { value: 0, label: '是' },
        { value: 1, label: '否' }
      ], //公益诉讼
      Draft: [
        { label: '已归档', value: true },
        { label: '未归档', value: false }
      ], //底稿资料
      step: [
        { value: '0', label: '全程' },
        { value: '1', label: '侦查阶段' },
        { value: '2', label: '审查起诉阶段' },
        { value: '3', label: '审判阶段' }
      ], //介入阶段
      Approve: [], //二次审批人
      Level: [
        { label: '一级', value: 1 },
        { label: '二级', value: 2 },
        { label: '三级', value: 3 }
      ], //案件级别
      Administrator: [
        { value: false, label: '未开设' },
        { value: true, label: '已开设' }
      ], //管理人
      ptype: [
        { label: '政府采购', value: 0 },
        { label: '国企采购', value: 1 },
        { label: '其他社会采购', value: 2 }
      ], //项目类型
      Lawyer: [], //代理律师

      date: [
        { value: '一月之内', label: '一月之内' },
        { value: '二月之内', label: '二月之内' },
        { value: '三月之内', label: '三月之内' }
      ],
      LinkCase: [], //关联案件
      form: {
        chargingMethod: '',
        extInfo: [],
        bcbdTable: [],
        bcbdTable: [],
        contractfile: [],
        ptfile: [], //普通附件
        chujuFiles:[],
        freeFile: [],
        administratorDecision: [],
        bidfile: [{ id: 1, fname: '江西银行-国贸物业物业费', ftype: 'doc' }], //投标方案
        Rulingfile: [], //法院的受理裁定书
        tableData: [],
        seal: {}
      },
      chargestatus: [
        { value: '免费', label: '免费' },
        { value: '固定收费', label: '固定收费' },
        { value: '风险收费', label: '风险收费' }
      ], //收费情况
      seal: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' },
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ], //合同用章

      logs: [],
      //审核弹出框
      approvaldialog: false,
      title: '',
      failformrules: {
        Reason: [
          { required: true, message: '驳回原因不能为空', trigger: 'change' },
          { validator: reason, trigger: 'blur' }
        ]
      },
      failform: {},
      // green: null, // 已过
      // redOrYellow: null, //审核中/未过
      // link: [],

      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      imgType: ['jpg', 'jpeg', 'png', 'pdf'],
      excelHtml: '',
      excelData: null,
      vHtml: null,
      isExcel: false,
      isWord: false,
      isImage: false,
      times: 1, //回退次数
      processlogs: [],
      Process: {},
      tjSuccessdialog: false,
      successformrules: {
        Reason: [
          { required: true, message: '通过条件不能为空', trigger: 'change' },
          { validator: reason, trigger: 'blur' }
        ]
      },
      successform: {},
      IsReacord: false,

      checkedCities: [],
      cities: null,
      sealbianji: true,
      isTj:false,
    }
  },

  methods: {
    chakan(item) {
      // console.log('item', item)
      if (item.casetype == '破产' || item.casetype == '破产投标') {
        this.$router.push({
          path: 'bankruptdetail',
          name: 'bankruptdetail',
          query: { guid: item.id, type: item.casetype, mystatus: 5 }
        })
      } else {
        this.$router.push({
          path: '/home/examine/Casedetail',
          query: {
            guid: item.id,
            type: this.$route.query.type,
            pages: this.$route.query.pages
          }
        })
        setTimeout(() => {
          // this.$router.go(0)
          window.location.reload()
        }, 1000)
      }
    },
    GetLink() {
      LinkCase({ Id: this.$route.query.guid, Type: this.casetype }).then(
        (res) => {
          if (res.data.status == 'success') {
            this.AllBidCase = res.data.data.bidCase
            this.AllBankruptCase = res.data.data.bankrupt
            this.AllCase = res.data.data.otherCase
            this.cStatus = res.data.data.status
            console.log(this.cStatus)
            // console.log(this.AllBidCase)
            // console.log(this.AllBankruptCase)
          }
        }
      )
    },
    Successlog() {
      CaseApprover({ CaseId: this.$route.query.guid }).then((res) => {
        if (res.data.status == 'success') {
          this.processlogs = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    rowStyle({ row, rowIndex }) {
      // console.log(row.isClient)
      if (row.isClient) {
        return 'success_class'
      }
      return ''
    },

    GetUser() {
      user({}).then((res) => {
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    // 绿色
    StepsDecide() {
      // var linkIndex = this.form.link.indexOf(this.form.ajstatus) // 当前案件节点
      // console.log('link', this.form.link)
      this.form.link.forEach((value, index, array) => {
        if (value.result == -1) {
          // 流程中
          array[index].result = 'process'
        } else if (value.result == 0) {
          // 审核通过
          array[index].result = 'success'
        } else if (value.result == 1) {
          // 审核不通过
          array[index].result = 'error'
        }
      })
    },

    handleCancle() {
      if (this.title == '通过条件') {
        this.$refs.successformref.resetFields()
      } else if (this.title == '驳回原因') {
        this.$refs.failformref.resetFields()
      }
      if (this.Isapproval) {
        this.$router.go(-1)
        this.Isapproval = false
      }
    },
    // 步骤条点击事件
    step_click(item) {
      if (item == this.Guid) {
        return
      }
      // this.$store.commit('setmenustatus', 1)
      // this.$router.push({
      //   path: '/home/case/caseinfo',
      //   query: {
      //     guid: item,
      //     status: this.form.typeId,
      //     caseType: this.form.typeId.substring(21, 23)
      //   }
      // })
      this.$router.push({
        path: '/home/examine/Casedetail',
        query: {
          guid: item,
          type: this.$route.query.type
        }
      })
      // this.$router.go(0)
      window.location.reload()
    },

    Getdetail() {
      this.isLoading = true
      Detail({ Id: this.Guid, Type: this.casetype }).then((res) => {
        if (res.data.status == 'success') {
          this.form = res.data.data
          if (res.data.data.cstatus == 1 && res.data.data.cresult == '-1') {
            this.shbtn = true
          }
          this.StepsDecide()
          this.form.fixed = this.form.fixed
          this.form.riskFixed = this.form.riskFixed
          this.form.riskRatio = this.form.riskRatio
          this.form.extInfo = JSON.parse(this.form.extInfo)
          if (this.form.tableData.length > 0) {
            this.CaseConflict()
            if(this.casetype!="破产案件"){
              this.AdviserConflict()
            }
            
          }
          if (this.form.seal == null) {
            this.form.seal = {
              sealId: null,
              sealType: ''
            }
          }
          this.GetProcess()

          if (this.form.seal.newsType != null) {
            var typeid = this.form.typeId
            // console.log('typeid', typeid)
            if (this.checkedCities.length > 0) {
              this.checkedCities = []
            }
            if (typeid == '00000000-0000-0000-0001-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '听证出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0001-0001-0002-000000000000') {
              this.cities = [
                {
                  name: '委托协议（辩护）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '为犯罪嫌疑人提供帮助的委托协议', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书（侦查）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书（检、审）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '会见专用介绍信（嫌疑人 被告人）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '取保候审申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '刑事案件代理委托协议（诉讼代理人）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书（刑事附带民事）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书（诉讼代表人）', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '调查取证申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '延期审理申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '解除强制措施申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '提请收集、调取证据申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '通知证人出庭申请书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '申请取保候审保证书', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '刑事案件事务所函', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师事务所函（侦查）', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师会见在押犯罪嫌疑人的函（侦查）', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师事务所函（检、审）', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0002-0002-0003-000000000000') {
              this.cities = [
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '行政复议出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0003-0003-0004-000000000000') {
              this.cities = [
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0004-0004-0005-000000000000') {
              this.cities = [
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0005-0005-0006-000000000000') {
              this.cities = [
                {
                  name: '授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(单位)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '执行授权委托书(个人)', // 模板名
                  type: 1, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                },
                {
                  name: '律师出庭函', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0006-0006-0007-000000000000') {
              this.cities = [
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                },
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (
              typeid == '00000000-0007-0007-0008-000000000000' ||
              typeid == '00000000-0013-0013-0014-000000000000'
            ) {
              this.cities = [
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0008-0008-0009-000000000000') {
              this.cities = [
                {
                  name: '法律意见书审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)

                  stype: ['law_seal'] // 用章类型
                },
                {
                  name: '单独出具律师函审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['legal_letter_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0009-0009-0010-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0010-0010-0011-000000000000'||typeid == '00000000-0014-0014-0015-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0011-0011-0012-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            } else if (typeid == '00000000-0012-0012-0013-000000000000') {
              this.cities = [
                {
                  name: '案件审批单', // 模板名
                  type: 2, // 类型(1:导出，2:打印)
                  stype: ['official_seal'] // 用章类型
                }
              ]
            }
            var oldCities = this.form.seal.newsType
            // console.log('oldCities', oldCities)
            // console.log('cities', this.cities)
            if (oldCities != null && oldCities != undefined) {
              oldCities.forEach((val) => {
                this.checkedCities.push(val.name)
                this.cities.forEach((v) => {
                  if (v.name == val.name) {
                    v.stype = val.stype
                  }
                })
              })
              const cC = new Set(this.checkedCities.map((m) => m))

              if (
                this.form.seal.sealResult != 1 ||
                this.form.seal.sealResult == null
              ) {
                var bbk = []
                this.cities.forEach((city, index, array) => {
                  // 不包含
                  if (!cC.has(city.name)) {
                    bbk.push(city.name)
                  }
                })
                this.cities = this.cities.filter(function (item) {
                  return !bbk.includes(item.name)
                })
              } else {
                this.cities.forEach((city) => {
                  // 不包含
                  if (!cC.has(city.name)) {
                    city.stype = []
                  }
                })
              }
            }
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
        this.isLoading = false
      })
    },
    history() {
      this.$router.go(-this.times)
      // setTimeout(() => {
      //   window.location.reload()
      // }, 100)
    },
    close() {
      if (this.imgUrl) {
        this.times = this.times + 1
        this.imgUrl = ''
      }
    },
    handlerError(data) {
      let enc = new TextDecoder('utf-8')
      var res = enc.decode(new Uint8Array(data))
      var jsonData = JSON.parse(res)
      //  console.log(jsonData)
      //  console.log(jsonData.status)
      if (
        jsonData.status == '401' ||
        jsonData.status == '402' ||
        jsonData.status == '403'
      ) {
        this.$message.error(jsonData.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
      // this.$message.error(enc.decode(new Uint8Array(res.data)))
    },
    // 预览文件
    look(item) {
      let fileType = item.ftype
      this.isLoading = true
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          this.dialogVisible = true
          this.isWord = false
          this.isExcel = false
          this.isImage = true
          //Image PDF
          YuLan({ Id: item.id }).then((res) => {
            if (res.data.type && res.data.type.includes('application/json')) {
              this.handlerResponseError(res.data)
            } else {
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else if (fileType === 'docx') {
          this.dialogVisible = true
          var vm = this
          //WORD
          this.isWord = true
          this.isExcel = false
          this.isImage = false
          requestReview({ Id: item.id }).then((res) => {
            // docx.renderAsync(data, this.$refs.word) // 渲染到页面预览

            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              mammoth
                .convertToHtml({ arrayBuffer: new Uint8Array(res.data) })
                .then(function (resultObject) {
                  vm.$nextTick(() => {
                    // document.querySelector("#wordView").innerHTML =
                    //   resultObject.value;
                    vm.vHtml = resultObject.value
                  })
                })
            }
          })
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          this.dialogVisible = true
          //EXCEL
          requestReview({ Id: item.id }).then((res) => {
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              this.isExcel = true
              this.isWord = false
              this.isImage = false
              const workbook = XLSX.read(new Uint8Array(res.data), {
                type: 'array'
              }) // 解析数据
              var worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
              // this.excelHtml = XLSX.utils.sheet_to_html(worksheet) // 渲染成html
              const sheet2JSONOpts = {
                /** Default value for null/undefined values */
                defval: '' // 给defval赋值为空的字符串,不然没值的这列就不显示
              }
              // 渲染成json
              this.excelData = XLSX.utils.sheet_to_json(
                worksheet,
                sheet2JSONOpts
              )
            }
          })
        } else {
          this.$message.error('不支持此文件预览')
        }
        this.isLoading = false
      } else {
        this.isLoading = false
        this.$message.error('不支持此文件预览')
      }
    },
    async down(item) {
      //下载
      this.isLoading = true
      const res = await requestDownLoadFile({
        Id: item.id
      })
      if (res.status == '201') {
        this.$message.error('找不到文件')
        return
      }
      if (res.data.type && res.data.type.includes('application/json')) {
        this.handlerResponseError(res.data)
      } else {
        this.getDownLoadFile(res.data, res['headers']['content-type'], item)
        this.GetLog()
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          }
          // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      this.isLoading = false
      fileReader.readAsText(data)
    },

    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null

      let fileType = row.ftype
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.fname + '.' + fileType)
        this.isLoading = false
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },

    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    //案件冲突
    CaseConflict(name) {
      var Attribute = ''
      var param;
      if(this.casetype=="破产案件"){
        Attribute="债务人"
        param=[{IsUnit: false, Name: this.form.extInfo.debtorName, IsClient: true, Attribute: "债务人",Idnumber:this.form.extInfo.idnumber,}]
      }if(this.casetype=="专项服务合同"){
        Attribute="客户名称"
        param=[{IsUnit: false, Name: this.form.extInfo.procureunit, IsClient: true, Attribute: "客户名称",Idnumber:this.form.extInfo.idnumber,}]
      }else{
        
        param = this.form.tableData
        this.form.tableData.forEach((value, index, array) => {
          if (value.isClient == true) {
            Attribute = value.attribute
            return
          }
        })
      }
      Conflict({
        listLitigant_param: param,
        CaseId: this.Guid,
        Attribute: Attribute
      }).then((res) => {
        if (res.data.status == 'success') {
          var Conflict = res.data.data
          this.$emit('conflict', Conflict)
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    AdviserConflict(name) {
      var Attribute = ''
      // console.log('tableData', this.form.tableData)
      this.form.tableData.forEach((value, index, array) => {
        if (value.isClient == true) {
          Attribute = value.attribute
          return
        }
      })
      AdviserConflict({
        listLitigant_param: this.form.tableData,
        Attribute: Attribute
      }).then((res) => {
        if (res.data.status == 'success') {
          var Adviser = res.data.data
          this.$emit('Aconflict', Adviser)
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    approvalReason() {
      this.title = '通过条件'
      this.tjSuccessdialog = true
      this.successform.id = this.Guid
      this.isTj=true
    },
    approval(type) {
      //审核
      var header = document.getElementsByClassName('el-dialog__header')
      if (type == 0) {
        // this.title = '备注'
        // this.tjSuccessdialog = true
        // this.successform.id = this.Guid
        // this.isTj=false
        this.title = ''
        header[0].style.display = 'none'
        this.failform.id = this.Guid
        this.success(this.failform.id)
      }
      if (type == 1) {
        this.title = '驳回原因'
        header[0].style.display = ''
        this.approvaldialog = true
        this.failform.id = this.Guid
      }
    },
    success(id) {
      //通过
      // console.log(this.form);
      this.isLoading = true
      Success({ Id: id }).then((res) => {
        if (res.data.status == 'success') {
          this.$message.success('审核成功')
          this.approvaldialog = true
          this.Isapproval = true
          this.$router.push('/home/examine/Caseapprove')
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
        this.isLoading = false
      })
    },
    refuse(form) {
      //驳回
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          Reject({ Id: this.failform.id, Reason: this.failform.Reason }).then(
            (res) => {
              if (res.data.status == 'success') {
                this.$message.success('审核成功')
                this.approvaldialog = false
                this.Isapproval = true
                this.$router.push('/home/examine/Caseapprove')
              } else if (
                res.data.status == '401' ||
                res.data.status == '402' ||
                res.data.status == '403'
              ) {
                this.$message.error(res.data.message)
                window.sessionStorage.removeItem('token')
                window.sessionStorage.removeItem('hasRoles')
                this.$router.push('/login')
              } else {
                this.approvaldialog = false
                this.$message.error(res.data.message)
              }
              this.isLoading = false
            }
          )
        } else {
          this.$message.error('有必填项为空！')
          return false
        }
      })
    },
    //有条件通过确定
    SuccessTJ(form) {
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          Success({
            Id: this.successform.id,
            Reason: this.successform.Reason,
            RemarkApproval:this.successform.RemarkApproval,
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success('审核成功')
              this.tjSuccessdialog = false
              this.Isapproval = true
              this.$router.push('/home/examine/Caseapprove')
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
            this.isLoading = false
          })
        } else {
          this.$message.error('有必填项为空！')
          return false
        }
      })
    },
    getFileType(filename) {
      let fix = filename
        .substring(filename.lastIndexOf('.') + 1)
        .toLocaleLowerCase()
      return fix
    },
    getFileName(filename) {
      let fix = filename
        .substring(0, filename.lastIndexOf('.'))
        .toLocaleLowerCase()
      return fix
    },
    // 时间格式
    handleTime(time) {
      if (time == null) {
        return time
      }
      var t = new Date(time)
      var time = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
      return time
    },
    handle(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    ChangeStaue(status) {
      if (status == null) {
        return status
      }
      if (status == 0) {
        return '已完成'
      }
      if (status == 1) {
        return '已禁用'
      }
      if (status == 2) {
        return '已提醒'
      }
      if (status == -1) {
        return '已删除'
      }
      if (status == 3) {
        return '待提醒'
      }
    },
    GetLog() {
      //获取日志
      CaseLog({ Id: this.Guid, type: 'case' }).then((res) => {
        if (res.data.status == 'success') {
          this.logs = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetProcess() {
      CaseProcess({ CaseId: this.Guid }).then((res) => {
        if (res.data.status == 'success') {
          this.Process = res.data.data
        } else if (
          res.status == '401' ||
          res.status == '402' ||
          res.status == '403'
        ) {
          this.$message.error(res.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    }
  },
  created() {
    this.Guid = this.$route.query.guid
    this.casetype = this.$route.query.type
    // if(this.casetype=='破产案件'){
    //   this.bcshow = false
    // }else{
    //   this.bcshow=true
    // }
    this.Getdetail()
    this.GetUser()
    this.GetLog()
    this.Successlog()
    if (this.$route.query.pages) {
      this.IsReacord = true
    }
    this.GetLink()
  },
  computed: {}
}
</script>
  
<style lang="less" scoped>
//  一审、二审
.Top {
  margin: 20px 0;
  // margin-left: 40px;
  display: flex; //把盒子在一行显示
  flex-wrap: wrap; //超出自动换行
  justify-content: center;
  margin: 20px 0;
  margin-left: 58px;
}

.el-steps--horizontal {
  width: 100%;
}

.Timeline {
  display: flex;
}

.timeaxis {
  display: flex;
  width: 16px;
  flex-direction: column;
  align-items: center;
}

.title {
  color: #3077e6;
  font-size: 16px;
  width: 80px;
  word-break: break-all;
}

.circular {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #3077e6;
}

.timeaxis-xian {
  width: calc(100% - 16px);
  height: 1px;
  border-bottom: 1px solid #c9cdd4;
  margin-top: 7px;
  min-width: 100px;
}

//主体
.text {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 19px;
  font-weight: 400;
  padding-left: 58px;
  margin-bottom: 32px;
}

.icon {
  width: 4px;
  height: 18px;
  background: #3077e6;
  border-radius: 9px;
  margin-right: 5px;
}

.contain {
  width: 100%;
}

.divider {
  width: calc(100% - 50px);
  margin: auto;
  float: right;
  border-top: 1px solid rgba(238, 239, 242, 1);
  margin-bottom: 32px;
  margin-top: 10px;
}

// 日历
::v-deep .el-input__prefix {
  display: none;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 15px;
}

.right {
  width: 70%;
  margin: auto;
  margin-top: 50px;
}

::v-deep .el-timeline-item {
  position: relative;
  padding-bottom: 20px;
  min-height: 100px;
}

.time {
  color: #909399;
}

//按钮
.footer {
  width: 100%;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 20px;
}
.tjtg {
  background: #cfb522;
  border-radius: 2px;
  color: #fafafa;
  border: none;
}
.history {
  border: 1px solid rgba(43, 200, 135, 1);
  color: rgba(43, 200, 135, 1);
}

// 表格
.party {
  width: 80%;
  margin: auto;
}

.party ::v-deep .el-input__inner {
  border: none;
}

.detail::v-deep .el-table th.el-table__cell {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: #fafafa;
}

// /deep/ .el-table tbody tr:hover>td {
//   background-color: #fff !important;
// }
::v-deep tbody tr:hover > td {
  background-color: transparent !important;
}

//当事人
/deep/ .el-table .success_class {
  background: #fff1dc;
}

.party {
  margin-bottom: 55px;
}

//附件
#Casedetail .fj {
  // display: inline-flex;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
  margin-bottom: 10px;
}

#Casedetail .fjimg {
  width: 16%;
  margin-bottom: 10px;
}

#Casedetail .upload_file img {
  width: 100%;
  height: 100%;
}

#Casedetail .upload_file {
  width: 360px;
}

#Casedetail .fname {
  width: 280px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#Casedetail /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}

#Casedetail .look {
  color: #fe964a;
  margin-right: 10px;
}

#Casedetail .down {
  color: #2bc887;
}

#Casedetail .word {
  line-height: 18px;
  cursor: default;
}

// 弹出框
#Casedetail /deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

#Casedetail .success {
  width: 100%;
  text-align: center;
  display: inline-flex;
  flex-direction: column;
}

#Casedetail .pass {
  color: #718096;
  font-size: 24px;
  margin-top: 12px;
}

#Casedetail .fail {
  width: 100%;
}

#Casedetail .refuse {
  width: 100%;
  text-align: center;
}

#Casedetail .money /deep/ .el-form-item__content {
  display: flex;
  align-items: center;
}

// /deep/ .el-table .error_class {
//     color: red;
// }
// ::v-deep .el-table--border th.el-table__cell,
// ::v-deep .el-table td.el-table__cell {
//   border-bottom: none !important;
// }

// ::v-deep .el-table--border .el-table__cell {
//   border-right: none !important;
// }

// ::v-deep .el-table td.el-table_cell,
// ::v-deep .el-table th.el-table__cell.is-leaf {
//   border-bottom: 0px solid #ebeef5 !important;
// }

// .el-table:before {
//   height: 0px;
// }
</style>
    